import React from "react"
import PopularCities from '../components/popular-cities'
import BlogPosts from '../components/blog-posts'
import ServicesDumpsters from "../components/services-dumpsters"
import LayoutDumpster from "../components/layout-dumpster"
import HowToGuidesSidebar from "../components/how-to-guides-sidebar"
import SidebarForm from "../components/sidebarForm"

const BLOGPAGEDUMPSTER = ({ pageContext }) => 
{ 
    const code = pageContext.code;
    const posts = pageContext.posts;
    const env = pageContext.env;       
    const ziptitle = 'Find the Right Pro. Simply.';

    const cities = pageContext.cities.length > 0 ? pageContext.cities : [];
    const paginationInfo = pageContext.pagination;

    const seo = 
    {
        url: 'blog',
        env: env,
        code: code,
        page: pageContext.tags ? 'tags' : 'blogs',
        tag: pageContext.tag?.name ? `${pageContext.tag.name} | Hometown Dumpster Rental Blog` : ''
    }

    const getTitle = () =>
    {
        let title = 'Waste Removal Tips & Advice';

        if(pageContext.tag != undefined)
        {
            if(pageContext.tag.name != undefined) title = pageContext.tag.name
        }

        return title
    }

    return (
        <LayoutDumpster seo={seo} env={env} code={code} bgcolor={'#f5f5f5'} hidden={true} callToAction={true}>
            <div className="blog">

                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="main-title">{getTitle()}</h1>
                            <BlogPosts posts={posts} paginationInfo={paginationInfo} site={env.site}/>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar">

                                <div className="block">
                                    <div className="card mb-5">                                   
                                        <SidebarForm site={env.site} code="dumpster" section="blogs"/>
                                    </div>
                                </div>

                                <div className="block">
                                    <div className="card mb-5">                                 
                                        <SidebarForm site={env.site} code="junk-removal" section="blogs"/>
                                    </div>
                                </div>  

                                <div className="block">
                                    <ServicesDumpsters env={env} />
                                </div>

                                <div className="block">
                                    <HowToGuidesSidebar />
                                </div>

                                <div className="block">
                                    <PopularCities env={env} cities={cities} />
                                </div>

                            </div>                            
                        </div>
                    </div>
                </div> 
            
            
            </div> 

        </LayoutDumpster>
    )
};

export default BLOGPAGEDUMPSTER;